export default __webpack_public_path__ + "static/media/a024-9.0f37bd22.svg";